/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const DeleteUserDefaultBudgetQueryParamOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteUserDefaultBudgetQueryParamOwner = ClosedEnum<
  typeof DeleteUserDefaultBudgetQueryParamOwner
>;

export type DeleteUserDefaultBudgetRequest = {
  owner: DeleteUserDefaultBudgetQueryParamOwner;
  orgId?: string | undefined;
};

export const DeleteUserDefaultBudgetScope = {
  Org: "org",
  Apikey: "apikey",
  User: "user",
  Team: "team",
  ExternalUser: "external_user",
  UserDefault: "user_default",
  TeamDefault: "team_default",
  ExternalUserDefault: "external_user_default",
} as const;
export type DeleteUserDefaultBudgetScope = ClosedEnum<
  typeof DeleteUserDefaultBudgetScope
>;

export const DeleteUserDefaultBudgetOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteUserDefaultBudgetOwner = ClosedEnum<
  typeof DeleteUserDefaultBudgetOwner
>;

/**
 * OK
 */
export type DeleteUserDefaultBudgetResponseBody = {
  scope: DeleteUserDefaultBudgetScope;
  scopeId: string;
  owner: DeleteUserDefaultBudgetOwner;
  deleted: true;
};

/** @internal */
export const DeleteUserDefaultBudgetQueryParamOwner$inboundSchema:
  z.ZodNativeEnum<typeof DeleteUserDefaultBudgetQueryParamOwner> = z.nativeEnum(
    DeleteUserDefaultBudgetQueryParamOwner,
  );
/** @internal */
export const DeleteUserDefaultBudgetQueryParamOwner$outboundSchema:
  z.ZodNativeEnum<typeof DeleteUserDefaultBudgetQueryParamOwner> =
    DeleteUserDefaultBudgetQueryParamOwner$inboundSchema;

/** @internal */
export const DeleteUserDefaultBudgetRequest$inboundSchema: z.ZodType<
  DeleteUserDefaultBudgetRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  owner: DeleteUserDefaultBudgetQueryParamOwner$inboundSchema,
  org_id: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
  });
});
/** @internal */
export type DeleteUserDefaultBudgetRequest$Outbound = {
  owner: string;
  org_id?: string | undefined;
};

/** @internal */
export const DeleteUserDefaultBudgetRequest$outboundSchema: z.ZodType<
  DeleteUserDefaultBudgetRequest$Outbound,
  z.ZodTypeDef,
  DeleteUserDefaultBudgetRequest
> = z.object({
  owner: DeleteUserDefaultBudgetQueryParamOwner$outboundSchema,
  orgId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
  });
});

export function deleteUserDefaultBudgetRequestToJSON(
  deleteUserDefaultBudgetRequest: DeleteUserDefaultBudgetRequest,
): string {
  return JSON.stringify(
    DeleteUserDefaultBudgetRequest$outboundSchema.parse(
      deleteUserDefaultBudgetRequest,
    ),
  );
}
export function deleteUserDefaultBudgetRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteUserDefaultBudgetRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteUserDefaultBudgetRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteUserDefaultBudgetRequest' from JSON`,
  );
}

/** @internal */
export const DeleteUserDefaultBudgetScope$inboundSchema: z.ZodNativeEnum<
  typeof DeleteUserDefaultBudgetScope
> = z.nativeEnum(DeleteUserDefaultBudgetScope);
/** @internal */
export const DeleteUserDefaultBudgetScope$outboundSchema: z.ZodNativeEnum<
  typeof DeleteUserDefaultBudgetScope
> = DeleteUserDefaultBudgetScope$inboundSchema;

/** @internal */
export const DeleteUserDefaultBudgetOwner$inboundSchema: z.ZodNativeEnum<
  typeof DeleteUserDefaultBudgetOwner
> = z.nativeEnum(DeleteUserDefaultBudgetOwner);
/** @internal */
export const DeleteUserDefaultBudgetOwner$outboundSchema: z.ZodNativeEnum<
  typeof DeleteUserDefaultBudgetOwner
> = DeleteUserDefaultBudgetOwner$inboundSchema;

/** @internal */
export const DeleteUserDefaultBudgetResponseBody$inboundSchema: z.ZodType<
  DeleteUserDefaultBudgetResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  scope: DeleteUserDefaultBudgetScope$inboundSchema,
  scope_id: z.string(),
  owner: DeleteUserDefaultBudgetOwner$inboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    "scope_id": "scopeId",
  });
});
/** @internal */
export type DeleteUserDefaultBudgetResponseBody$Outbound = {
  scope: string;
  scope_id: string;
  owner: string;
  deleted: true;
};

/** @internal */
export const DeleteUserDefaultBudgetResponseBody$outboundSchema: z.ZodType<
  DeleteUserDefaultBudgetResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteUserDefaultBudgetResponseBody
> = z.object({
  scope: DeleteUserDefaultBudgetScope$outboundSchema,
  scopeId: z.string(),
  owner: DeleteUserDefaultBudgetOwner$outboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    scopeId: "scope_id",
  });
});

export function deleteUserDefaultBudgetResponseBodyToJSON(
  deleteUserDefaultBudgetResponseBody: DeleteUserDefaultBudgetResponseBody,
): string {
  return JSON.stringify(
    DeleteUserDefaultBudgetResponseBody$outboundSchema.parse(
      deleteUserDefaultBudgetResponseBody,
    ),
  );
}
export function deleteUserDefaultBudgetResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<DeleteUserDefaultBudgetResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DeleteUserDefaultBudgetResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteUserDefaultBudgetResponseBody' from JSON`,
  );
}
